import React, { useEffect, useState } from "react";
import GeneralHeader from "./GeneralHeader";
// import HomeLandingHeader from "./HomeLanding"; commeneted old Header
import HomeLandingHeader from "./HomeLandingNew";
import NavHeader from "./NavHeader";
import { useLocation } from "react-router-dom";

const Header = () => {
  const [header, setHeader] = useState(<GeneralHeader />);
  const location = useLocation();
  var path = window.location.pathname;
  useEffect(() => {
    console.log(location.pathname);
    const path_array = path.split("/");

    if (path_array[1] === "costdemaze") {
      setHeader(
        <NavHeader
          classList={"custimize-drop-down-list"}
          classHeader={"costimize_header"}
          headerText={"CostDeMaze"}
          type="costdemaze"
        />
      );
    } else if (path_array[1] === "operation") {
      setHeader(<HomeLandingHeader />);
    } else if (path_array[1] === "cams") {
      // setHeader(<CamsHeader />);
      setHeader(
        <NavHeader
          classHeader={"cams_header"}
          headerText={"SA"}
          classList={"slm-drop-down-list"}
          type="smart_alert"
        />
      );
    } else if (path_array[1] === "slm") {
      setHeader(
        <NavHeader
          classHeader={"cams_header"}
          headerText={"SLM"}
          classList={"slm-drop-down-list"}
          type="slm"
        />
      );
    } else if (path_array[1] === "peems") {
      setHeader(
        <NavHeader
          classHeader={"cams_header"}
          headerText={"EE"}
          classList={"slm-drop-down-list"}
          type="event_express"
        />
      );
    } else if (path_array[1] === "billing") {
      setHeader(
        <NavHeader
          classHeader={"cams_header"}
          headerText={"Billing"}
          classList={"slm-drop-down-list"}
          type="billing"
        />
      );
    } else if (path_array[1] === "old_operation") {
      setHeader(
        <NavHeader
          classHeader={"cams_header"}
          headerText={"RAMS"}
          classList={"slm-drop-down-list"}
          type="old_operation"
        />
      );
    } else if (path_array[1] === "devops") {
      setHeader(
        <NavHeader
          classHeader={"devops_header"}
          headerText={"DevOps"}
          classList={"slm-drop-down-list"}
          type="devops"
        />
      );
    } else if (
      path_array[1] === "admin-dashboard" ||
      path_array[1] === "user-mng" ||
      path_array[1] === "role-management" ||
      path_array[1] === "account-onboarding" ||
      path_array[1] === "register-new-customer"
    ) {
      setHeader(
        <NavHeader classHeader={"admindashboard_header"} type="user" />
      );
    } else if (path_array[1] === "signin" || path_array[1] === "signup") {
      setHeader(<HomeLandingHeader />);
    } else if (path === "/") {
      // setHeader(<HomeLandingHeader />);
      setHeader();
    } else if (path_array[1] === "azure-auth") {
      setHeader();
    } else {
      setHeader(
        <NavHeader classHeader={"admindashboard_header"} type="user" />
      );
    }
  }, [window.location.pathname]);

  return <>{header}</>;
};
export default Header;
